import {
    Form,
    Input,
    Select,
    Radio,
    DatePicker,
    Checkbox,
    Button,
    notification,
    Spin,
    message,
    Modal,
} from "antd";
import React, { useEffect, useState } from 'react'
import moment from 'moment';

function BidSoldModal({ soldModal, handleCancel, onFinish, currentPrice, loader }) {


    const [bidSoldtDate, setBidSoldtDate] = useState(Date.now())
    const [paymentMethod, setPaymentMethod] = useState("card");


    const [form1] = Form.useForm();

    useEffect(() => {

        setBidSoldtDate(moment()); // Set to current date
        form1.setFieldsValue({ startDate: moment() }); // Reset the start date in the form

    }, [form1]);

    const handlePaymentMethod = (e) => {
        setPaymentMethod(e.target.value);
    };

    // console.log(currentPrice,'currentPrice');


    return (
        <div>
            <Modal
                open={soldModal}
                onCancel={handleCancel}
                footer={null}
                title="Sold Details"
            >
                <div className="p-4">
                    <Form
                        name="Bid Approval"
                        form={form1}
                        initialValues={{ bidPrice: currentPrice, }}
                        onFinish={onFinish}
                    >
                        {/* Bid Type */}
                        <div >
                            <label htmlFor="" className="mb-2">Payment Method</label>
                            <Form.Item name="paymentMethod"
                            //  label="Payment Method"
                            rules={[
                                { required: true, message: 'Please select the payment method.' },
                            ]} >
                                <Radio.Group
                                    onChange={handlePaymentMethod}
                                    defaultValue={paymentMethod}
                                    value={paymentMethod}
                                    className="flex-col"
                                >
                                    <Radio value="now">Cash</Radio>
                                    <Radio value="card">Credit/Debit crad</Radio>
                                    <Radio value="internetBanking">Internet Banking</Radio>
                                    <Radio value="upi">UPI</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </div>



                        <>
                            {/* Bid Start Date */}
                            <Form.Item
                                label="Sold Date"
                                name="startDate"
                                rules={[
                                    { required: true, message: 'Please select the sold date.' },
                                ]}
                            >
                                <DatePicker
                                    value={bidSoldtDate}
                                    showTime
                                    placeholder="Select sold date"
                                    className="w-full"
                                    dropdownStyle={{ maxHeight: '200px', overflowY: 'auto' }} // Adjust as needed

                                />
                            </Form.Item>

                        </>



                        <>
                            {/* bid Price */}
                            <Form.Item
                                label="Bid Price"
                                name="bidPrice"
                                val
                                rules={[
                                    { required: true, message: 'Please enter the bid price.' },
                                ]}
                            >
                                <Input
                                    type="number"
                                    placeholder="Enter bid  price"
                                    className="border-[#A3BBFF] border text-[#4A4A4C] text-base font-normal"
                                />
                            </Form.Item>

                            {/* bid commission */}
                            <Form.Item
                                label="Bid Commission"
                                name="bidCommission"
                                rules={[
                                    { required: true, message: 'Please enter the bid commission.' },
                                ]}
                            >
                                <Input
                                    type="number"
                                    placeholder="Enter bid  price"
                                    className="border-[#A3BBFF] border text-[#4A4A4C] text-base font-normal"
                                />
                            </Form.Item>




                        </>



                        {/* Submit and Cancel Buttons */}
                        <div className="flex justify-end mt-3">
                            <Button onClick={handleCancel} className="py-3 px-6 mr-4 font-semibold">
                                Dismiss
                            </Button>
                            <Button htmlType="submit" loading={loader} className="bg-blue-500 py-3 px-6 text-white font-medium">
                                Submit
                            </Button>
                        </div>
                    </Form>
                </div>
            </Modal >
        </div >
    )
}

export default BidSoldModal